function onBundlesAppRendered() {
  const upsellProducts = document.querySelector('.product-upsells');

  if (upsellProducts) {
    upsellProducts.classList.add('bundles')
  }
}

const existingBundlesBlock = document.querySelector('.kaching-bundles');

if (existingBundlesBlock) {
  onBundlesAppRendered();
} else {
  const buyButtonsContainer = document.querySelector('.buy-buttons--container kaching-bundle');

  if (buyButtonsContainer) {
    const observer = new MutationObserver((mutationsList, observer) => {
      for (const mutation of mutationsList) {
        if (mutation.type === 'childList') {
          const addedNodes = Array.from(mutation.addedNodes);
          for (const node of addedNodes) {
            if (node.nodeType === 1 && node.classList.contains('kaching-bundles')) {
              onBundlesAppRendered();
              observer.disconnect();
              return;
            }
          }
        }
      }
    });

    observer.observe(buyButtonsContainer, {childList: true, subtree: true});
  }
}
